import React, { useState, useRef } from "react";
import ReactSelect, { components } from "react-select";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({
  searchIcon,
  clearSearchBar,
  dataArray,
  onChange,
  inputRef,
  placeholder,
  isClearable,
  label,
  handleInputChange,
  onKeyDown,
}) => {
  const selectStyles = {
    menu: (styles) => ({
      ...styles,
      position: "absolute",
      minWidth: "100%",
      boxShadow: "0 20px 54px 0 rgba(0,0,0,0.2)",
      zIndex: 20,
      margin: 0,
      // fontStyle: "normal",
      fontSize: "14px",
      // lineHeight: "24px"
    }),
    control: (Colstyles, state) => ({
      ...Colstyles,
      borderRadius: "5px",
      minHeight: "2.25rem",
      overflow: "clipped",
      whiteSpace: "nowrap",
      flexWrap: "nowrap",
      margin: 0,
      fontSize: "14px",
      minWidth: "100%",
    }),
    input: (provided, state) => ({
      ...provided,
      margin: 0,
      fontSize: "14px",
      overflow: "clip",
    }),
  };
  if (isClearable !== false) {
    isClearable = true;
  }
  const [inputValue, setInputValue] = useState("");

  const selectInputRef = useRef();

  const onClear = () => {
    selectInputRef.current.select.clearValue();
    setInputValue("");
    // selectInputRef.current.select.focus()
  };

  const handleOnChange = (e) => {
    console.log("12345678",e);
    
    setInputValue("");
    onChange(e);
    if (clearSearchBar) {
      onClear();
    }
  };
  const handleInputChangeFunc = (string, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      handleInputChange(string);
      setInputValue(string);
    }
  };
  return (
    <div className=" w-full">
      <ReactSelect
        inputValue={inputValue}
        ref={selectInputRef}
        options={dataArray}
        placeholder={placeholder}
        openMenuOnClick={false}
        isClearable={isClearable}
        inputRef={inputRef}
        clearValue={true}
        styles={selectStyles}
        components={{
          DropdownIndicator: () =>
            searchIcon ? (
              <SearchIcon className=" mr-4 text-slate-500 " />
            ) : null,
          IndicatorSeparator: () => null,
        }}
        // onInputChange={handleChange}

        onInputChange={handleInputChangeFunc.bind(this)}
        onChange={handleOnChange}
        blurInputOnSelect
        controlShouldRenderValue={!clearSearchBar}
        // getOptionValue={(option) => `${option['label']}`}

        onKeyDown={onKeyDown}
      />
    </div>
  );
};
export default SearchBar;
